import axios from 'axios';

import { GetFilesParams } from 'types/user';
import * as qs from 'qs';
import { FormPostSeizure } from '../app/pages/Admin/RedemptionPage/PostSeizurePage/components/modules/FormPostSeizure/FormPostSeizure';

export const getFiles = async (params: Partial<GetFilesParams>) => {
  const query = qs.stringify({
    ...params,
    earlyMorning: params.earlyMorning || undefined,
    doorKnock: params.doorKnock || undefined,
    status: params.status,
    types: params.types
  });
  console.log(query);
  const { data } = await axios.get(`/files?${query}`);
  return data;
};
export type BailiffUpdateFile = {
  quickNote: string;
};
export const bailiffUpdateFile = async (id: number, payload: BailiffUpdateFile) => {
  const { data } = await axios.put(`/files/${id}`, payload);
  return data;
};

export const deleteNoteByFile = async (idNote: number) => {
  const { data } = await axios.delete(`/files/${idNote}/notes`);
  return data;
};
export const getFilesNotDispatch = async (params: { size: number; page: number }) => {
  const query = qs.stringify({
    ...params
  });
  const { data } = await axios.get(`/admin/file-not-dispatch?${query}`);
  return data;
};

export type CreateFilePayload = {
  fileNumber: string;
  firstName: string;
  lastName: string;
  vin: string;
  model: string;
  make: string;
  year: number | string;
  arrears: number;
  contractBalance: number;
  ppsaBaseRegistrationNumber: string;
  ppsaRegistrationDate: Date;
  contactDate: Date;
  auctionDeliveryLocationId: number;
  clientOptionsId: number;
};

export type CreateSeizurePayload = {
  fileId: number;
  quickNote?: string;
  bailiffFees?: number;
  redemptionFees?: number;
  addressLeadId?: number;
  lenderFees?: number;
  arrears?: number;
  arrearsTo?: string;
  fctFees?: number;
  auctionHouseFees?: number | null;
  auctionHouseFeesText?: string | null;
  transportFeesText?: string | null;
  storageFees?: number;
  escFees?: number;
  otherFees?: number;
  transportFees?: number | null;
  mvsSearch?: number;
  nextPayment?: number;
  nextPaymentDate?: string;
  installmentAmount?: number;
  frequency?: string;
  otherFeesIncurred?: string;
  phoneNumber?: string;
  email?: string;
  employer?: string;
  employerPhone?: string;
  provider?: string;
  policy?: string;
  expiryDate?: string;
  documentIds?: number[];
  status?: string;
  apptDate?: string;
  followUpSent?: string;
  statementSent?: string;
};

export const renderPayloadSeizure = (formData: FormPostSeizure, filePhotosIds: number[]) => {
  const auctionFeesValue = formData.costDetail?.auctionFees;
  const transportFeesValue = formData.costDetail?.transportFees;

  const isAuctionFeesNumber = auctionFeesValue && !isNaN(auctionFeesValue as number);
  const isTransportFeesNumber = transportFeesValue && !isNaN(transportFeesValue as number);
  /* eslint-disable @typescript-eslint/no-explicit-any */
  const payload: any = {
    fileId: Number(formData.fileId),
    quickNote: formData.quickNote,
    bailiffFees: formData.costDetail?.bailiffFees ?? null,
    addressLeadId: formData?.debtorDetail?.address ? Number(formData?.debtorDetail?.address) : null,
    redemptionFees: formData.costDetail?.redemptionFees ?? null,
    auctionHouseFees: isAuctionFeesNumber ? Number(auctionFeesValue) : null,
    auctionHouseFeesText: !isAuctionFeesNumber ? String(auctionFeesValue) : null,
    transportFees: isTransportFeesNumber ? Number(transportFeesValue) : null,
    transportFeesText: !isTransportFeesNumber ? String(transportFeesValue) : null,
    arrears: formData.costDetail?.arrears ?? null,
    arrearsTo: formData.costDetail?.arrearsTo ?? null,
    escFees: formData.costDetail?.clientFees ?? null,
    otherFees: formData.costDetail?.otherFees ?? null,
    mvsSearch: formData.costDetail?.mvsFees ?? null,
    nextPayment: formData.nextPaymentDetail.installmentAmount,
    nextPaymentDate: formData.nextPaymentDetail?.nextPaymentDate
      ? new Date(formData.nextPaymentDetail.nextPaymentDate).toISOString()
      : null,
    installmentAmount: formData.nextPaymentDetail?.installmentAmount
      ? Number(formData.nextPaymentDetail.installmentAmount)
      : 0,
    frequency: formData.nextPaymentDetail?.frequency,
    otherFeesIncurred: formData.costDetail?.otherFeesIncurred,
    phoneNumber: formData.debtorDetail?.phoneNumber,
    email: formData.debtorDetail?.email,
    employer: formData.debtorDetail?.employer,
    employerPhone: formData.debtorDetail?.employerPhone,
    provider: formData.insuranceDetail?.provider,
    policy: formData.insuranceDetail?.policyNumber,
    expiryDate: formData.insuranceDetail?.expiry
      ? new Date(formData.insuranceDetail.expiry).toISOString()
      : null,
    documentIds: filePhotosIds
  };
  console.log(payload);
  return payload;
};

export type UpdateFilePayload = Partial<CreateFilePayload> & {
  redemption?: boolean;
};

// admin
export const createFiles = async (payload: CreateFilePayload) => {
  const { data: res } = await axios.post('/admin/files', payload);
  return res;
};
export const updateFiles = async (id: number, payload: UpdateFilePayload) => {
  const { data: res } = await axios.put(`/admin/files/${id}`, payload);
  return res;
};

export const onHoldFile = async (id: number, onHold: boolean) => {
  const { data: res } = await axios.put(`/admin/file/on-hold/${id}`, { onHold });
  return res;
};

export const deleteFile = async (id: number) => {
  const { data: res } = await axios.delete(`/admin/files/${id}`);
  return res;
};

export const updateStatusTransition = async (id: number, payload: string) => {
  const { data: res } = await axios.put(`/files/status-transition/${id}`, { status: payload });
  return res;
};
export const updatePreSeizuresFail = async (id: number) => {
  const { data: res } = await axios.put(`/file-pre-seizures/fail/${id}`);
  return res;
};

export const getCountFileByStatus = async () => {
  const { data } = await axios.get('/admin/file-status');
  return data;
};

export const createSeizure = async (payload: CreateSeizurePayload) => {
  const { data: res } = await axios.post('/file-post-seizures', payload);
  return res;
};

export const getDetailSeizure = async (id: number) => {
  const { data: res } = await axios.get(`/seizure-reports/${id}`);
  return res;
};

export const getDetailPostSeizure = async (id: number) => {
  const { data } = await axios.get(`/file-post-seizures/${id}`);
  return data;
};

export const updateDetailPostSeizure = async (
  id: number,
  payload: Partial<CreateSeizurePayload>
) => {
  const { data } = await axios.put(`/file-post-seizures/${id}`, payload);
  return data;
};

export const generatePostSeizure = async (id: number, payload: Partial<CreateSeizurePayload>) => {
  const { data: res } = await axios.post(`/file-post-seizures/${id}/generate`, payload);
  return res;
};
export const generatePreSeizure = async (id: number, payload: Partial<CreateSeizurePayload>) => {
  const { data: res } = await axios.post(`/file-pre-seizures/${id}/generate`, payload);
  return res;
};

export const createPreSeizure = async (payload: Partial<CreateSeizurePayload>) => {
  const { data: res } = await axios.post('/file-pre-seizures', payload);
  return res;
};

export const getDetailPreSeizure = async (id: number) => {
  const { data } = await axios.get(`/file-pre-seizures/${id}`);
  return data;
};

export const updateDetailPreSeizure = async (
  id: number,
  payload: Partial<CreateSeizurePayload>
) => {
  const { data } = await axios.put(`/file-pre-seizures/${id}`, payload);
  return data;
};
// bailiff

export const getFilesById = async (id: number) => {
  const { data: res } = await axios.get(`/files/${id}`);
  return res;
};
export const updateFilesBailiff = async (id: number, payload: string) => {
  const { data: res } = await axios.put(`/files/status-transition/${id}`, { status: payload });
  return res;
};

export const getOptionFile = async () => {
  const [{ data: resOptionClient }, { data: resOptionAuctionDeliveryLocation }] = await Promise.all(
    [axios.get(`/client-options`), axios.get(`/auction-delivery-locations`)]
  );
  return { resOptionClient, resOptionAuctionDeliveryLocation };
};

export type payloadDispatchFile = {
  fileId: number;
  userIds: number[];
};
export const dispatchFiles = async (payload: payloadDispatchFile) => {
  const { data: res } = await axios.put('/dispatch-files', payload);
  return res.dispatchFiles;
};

export const getFileArchive = async (params: {
  page: number;
  size: number;
  keyword?: number;
  sortBy?: string;
  order?: string;
}) => {
  const query = qs.stringify({
    ...params
  });
  const { data } = await axios.get(`/files/archives?${query}`);
  return data;
};

export type GetFileInboxParams = {
  page: number;
  size: number;
};

export type GetFileInboxDetailParams = {
  page: number;
  size: number;
};

export const getListFileInbox = async (params: GetFileInboxParams) => {
  const query = qs.stringify({
    ...params
  });

  const { data } = await axios.get(`/files/inbox?${query}`);
  return data;
};

export const getDetailFileInbox = async (fileId: number, params: GetFileInboxDetailParams) => {
  const query = qs.stringify({
    ...params
  });

  const { data } = await axios.get(`/files/inbox/${fileId}?${query}`);
  return data;
};

export const getFilesChat = async (params: { size: number; page: number }) => {
  const query = qs.stringify({
    ...params
  });
  const { data } = await axios.get(`/communication/inbox?${query}`);
  return data;
};
export const getDetailFilesChat = async (
  params: { size: number; page: number },
  fileId: number
) => {
  const query = qs.stringify({
    ...params
  });
  const { data } = await axios.get(`/communication/inbox/${fileId}?${query}`);
  return data;
};
export const createInboxChat = async (content: string, fileId: number) => {
  const { data } = await axios.post(`/communication/inbox/${fileId}`, { content });
  return data;
};
export const deleteInboxChat = async (idChat: number) => {
  const { data } = await axios.delete(`/communication/inbox/${idChat}`);
  return data;
};
export const hiddenInboxChat = async (idChat: number) => {
  const { data } = await axios.delete(`/communication/inbox/${idChat}/hidden`);
  return data;
};

export const hiddenInboxChatByFileId = async (fileId: number) => {
  const { data } = await axios.put(`/files/inbox/${fileId}/hide`);
  return data;
};

export const exportTowYard = async () => {
  const data = await axios.post('/files/export/towyards');
  return data;
};
export const requestedMvs = async (fileId: number, mvsRequested: boolean = true) => {
  const data = await axios.put(`/files/${fileId}/request-mvs`, { mvsRequested });
  return data;
};
